import React, { useEffect } from 'react';

import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import ErrorBoundary from '../Components/ErrorBoundary/ErrorBoundary';
import OptionDetail from '../Components/OptionDetail/OptionDetail';
import * as actionTypes from '../store/actions/index';

function ProviderPreviewComponent(props) {
  const { surveyId } = useParams();

  useEffect(() => {
    props.setApiData(surveyId, null);
    // eslint-disable-next-line
  }, []);
  const { data } = props;

  const option = data;

  return (
    <div className="App">
      <ErrorBoundary>
        <div>
          <div className="optionDetail">
            <OptionDetail
              option={option}
              idProp={option.id}
              showNav={false}
              isShortlistedSearch={'preview'}
            />
          </div>
        </div>
      </ErrorBoundary>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    data: state.optRed.data,
    displayDate: state.comRed.displayDate,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setApiData: (optionId) => dispatch(actionTypes.providerPreviewAction(optionId, null)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProviderPreviewComponent);
